export default "__VITE_ASSET__ddc97e0e__"